import EventsPage from "../Pages/events-page/EventsPage";

const eventsRoutes = [
    {
      path: "/agccProjects",
      element: <EventsPage />
    },
  ];
  
  export default eventsRoutes;